import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";

import { NgbModal, NgbModalRef, NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";

import { TranslationService } from "../../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import {
  FamilyMemberModel,
  FamilyModel,
} from "../brother-attribution-models/family-model";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import { ChildObjectForEdit } from "../brother-attribution-family-editor/brother-attribution-family-editor.component";
import { BrotherAttributionService } from "../../../_services/brother-attribution.service";

@Component({
  selector: "family-creation-form",
  templateUrl: "./family-creation-form.component.html",
  styleUrls: ["./family-creation-form.component.scss"],
})
export class FamilyCreationFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Output("modalAction") public modalAction: EventEmitter<"close" | "save"> =
    new EventEmitter<"close" | "save">();

  public disableSave: boolean = true;

  public translations$: Observable<ITranslations>;
  private familyStatus: Array<
    FamilyMemberModel & { status: "new" | "exiting" | "deleted" }
  > = [];

  constructor(
    protected dataService: DataService,
    protected authenticationService: AuthenticationService,
    protected router: Router,
    protected modalService: NgbModal,
    protected changeDetectorRef: ChangeDetectorRef,
    protected translationService: TranslationService,
    private brotherAttributionService: BrotherAttributionService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {}

  public ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  public ngOnDestroy(): void {}

  public async saveChanges(number: number) {
    const startText = "החניכים הבאים שוייכו  בהצלחה אחד לשני:";
    const dataForPostAction = this.familyStatus.map((f) => ({
      id: f.id.toString(),
      status: f.status,
    }));
    const saveResult = await this.brotherAttributionService.saveFamilyChanges(
      dataForPostAction
    );

    if (saveResult.success === false) {
      await this.modalNotification(
        this.translationService.currentTranslations.general_error +
          " " +
          saveResult.error.toString()
      );
      return;
    }

    const names = this.familyStatus.map((f) => f.firstName + " " + f.lastName);
    const finalText = `${startText} ${names.join(", ")}`;
    this.modalNotification(finalText).then();
  }

  public async closeParentEventModal() {
    this.modalAction.emit("close");
  }

  public updateFamilyStatus($event: ChildObjectForEdit[]) {
    this.familyStatus = $event;
    this.disableSave = this.familyStatus.length <= 1;
  }
  protected async modalNotification(message: string) {
    let modalText = message.toString();

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שיוך אחים ואחיות",
      modalText,
      onlyApprove: true,
    };
    await modalRef.result;
    await this.closeParentEventModal();
  }
  protected handleError(err: any) {
    const isDisconnected = err.status === 401;
    const noUserPermission = err.status === 400;
    let modalText = err.toString();
    if (noUserPermission) {
      modalText = `אין לך הרשאה מספקת לערוך  `;
    } else if (isDisconnected) {
      modalText = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    }

    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);
    modalRef.componentInstance.modalOptions = {
      approveOption: "אישור",
      cancelOption: "",
      modalHeader: "שגיאה",
      modalText,
      onlyApprove: true,
    };
    modalRef.result.then((res) => {
      this.closeParentEventModal().then((r) => r);
      if (isDisconnected) {
        setTimeout(() => this.router.navigate(["/login"]), 1000);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/brothers-attribution/family-creation-form/family-creation-form.component.ts